import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import BusinessLookupWizard from "@/pages/BusinessLookupWizard";
import ReportDashboard from "@/pages/ReportDashboard";
import ReportsList from "@/pages/ReportsList";
import PricingPage from "@/pages/PricingPage";
import ReviewsDashboard from "@/pages/ReviewsDashboard";
import CampaignsList, { CampaignDetail } from "@/pages/CampaignManager";
import PriceReport from "@/pages/PriceReport";
import AdminLogin from "@/pages/AdminLogin";
import RequireAdmin from "@/components/RequireAdmin";
import { installAdminAuth } from "@/lib/adminAuth";

installAdminAuth();

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/lookup" element={<BusinessLookupWizard />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/reports" element={<RequireAdmin><ReportsList /></RequireAdmin>} />
          <Route path="/report/:reportId" element={<ReportDashboard />} />
          <Route path="/report/:reportId/sales" element={<RequireAdmin><PriceReport /></RequireAdmin>} />
          <Route path="/reviews/:businessId" element={<RequireAdmin><ReviewsDashboard /></RequireAdmin>} />
          <Route path="/campaigns" element={<RequireAdmin><CampaignsList /></RequireAdmin>} />
          <Route path="/campaigns/:campaignId" element={<RequireAdmin><CampaignDetail /></RequireAdmin>} />
          <Route path="/pricing" element={<PricingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
